import React from 'react';
import { View } from 'react-native';
import CornerBottomRightSvg from '@assets/images/svg/doc-capture/corner-bottom-right.svg';

export interface CornerBottomRightIconProps {
    size?: number;
}

export function CornerBottomRightIcon({ size = 71 }: CornerBottomRightIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CornerBottomRightSvg width={size} height={size} />
        </View>
    );
}

export default CornerBottomRightIcon;

